/*
 * Skin tabs for the Shop the Look Collection section.
 *
 * Each tab maps to a `skin_tab` block setting (1/2/3). Clicking a tab:
 *  - sets `data-active-skin` on the section root (CSS hides non-matching
 *    images, hotspots, sliders, and quick-view items)
 *  - re-runs Flickity `resize()` on the now-visible grid sliders so they
 *    measure correctly after being un-hidden
 *  - activates the first hotspot of the new skin so the slider/quick-view
 *    matches the visible hotspots
 */
(function () {
  function resizeFlickityIn(scope) {
    scope
      .querySelectorAll('[data-look-collection-flickity]')
      .forEach(function (track) {
        if (window.Flickity) {
          var f = window.Flickity.data(track);
          if (f) f.resize();
        }
        track.dispatchEvent(new CustomEvent('look:flickity:resize', {bubbles: true}));
      });
  }

  function activateSkin(section, skin) {
    if (!section || !skin) return;
    if (section.dataset.activeSkin === skin) return;

    section.dataset.activeSkin = skin;

    section.querySelectorAll('[data-skin-tab-trigger]').forEach(function (btn) {
      var isActive = btn.getAttribute('data-skin-tab-trigger') === skin;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    section.querySelectorAll('.look__image-wrap[data-skin-tab]').forEach(function (wrap) {
      if (wrap.getAttribute('data-skin-tab') === skin) {
        wrap.removeAttribute('hidden');
      } else {
        wrap.setAttribute('hidden', '');
      }
    });

    // look-collection-sliders.js leaves inline style.display="none" on
    // sliders the user previously hid via hotspot clicks. Clear them so
    // CSS (which hides by data-skin-tab) is in charge again.
    section.querySelectorAll('look-collection-grid-slider').forEach(function (slider) {
      slider.style.display = '';
    });

    // Surface the first hotspot of the active skin so its grid slider
    // becomes the "active" one. Dispatching a real click reuses the
    // existing switchCollectionByIndex logic in look-collection-sliders.js.
    // On mobile we skip the auto-click so the products popup only opens
    // when the user explicitly taps a hotspot.
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
    var firstPointer = section.querySelector(
      '.hotspot[data-skin-tab="' + skin + '"] [data-pointer]'
    );
    if (firstPointer && !isMobile) {
      firstPointer.click();
    }

    requestAnimationFrame(function () {
      resizeFlickityIn(section);
    });
  }

  function init(section) {
    if (!section || section._skinTabsInit) return;
    section._skinTabsInit = true;

    section.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('[data-skin-tab-trigger]');
      if (!trigger || !section.contains(trigger)) return;
      event.preventDefault();
      activateSkin(section, trigger.getAttribute('data-skin-tab-trigger'));
    });
  }

  function initAll() {
    document
      .querySelectorAll('[data-section-type="look-collection"][data-active-skin]')
      .forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify section reload in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target;
    if (!root || !root.querySelector) return;
    root
      .querySelectorAll('[data-section-type="look-collection"][data-active-skin]')
      .forEach(init);
  });
})();
